export default "__VITE_PUBLIC_ASSET__80365f4e__"